import { h } from 'vue'
import OrganismCallToAction from '~/components/organisms/call-to-action/call-to-action.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(
    UiComponentContainer,
    {
      class: 'get-started',
      end: 1,
      start: 1,
    },
    () => [
      h(OrganismCallToAction, {
        features: props.callToActionFeatures,
        primaryButton: {
          ...props.primaryButton,
          label: 'Get started section CTA',
        },
        secondaryButton: {
          ...props.secondaryButton,
          label: 'Get started section CTA',
        },
        theme: 'new',
      }, {
        heading: () => props.record.title,
        paragraph: () => props.record.text,
      }),
    ],
  )
}

Functional.props = {
  callToActionFeatures: {
    required: true,
    type: Object,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  secondaryButton: {
    required: true,
    type: Object,
  },
}

export default Functional
